import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ColumnPopupFilterTextPropTypes } from 'src/components/DataGrid/ColumnPopup/ColumnPopupFilters/propTypes';
import s from 'src/components/DataGrid/ColumnPopup/ColumnPopupFilters/ColumnFilters.styles';
import TextField from 'src/components/TextField';

const ColumnPopupFilterText = ({ onChange, onClose, value }) => {
  const [localValue, setLocalValue] = useState(value[0] || '');
  const { t } = useTranslation();

  const onSubmit = () => {
    onChange([localValue.trim()]);
    onClose();
  };

  return (
    <s.MorePopup>
      <s.PopupTextField>
        <TextField
          onChange={e => setLocalValue(e.target.value)}
          onKeyUp={e => e.keyCode === 13 && onSubmit()}
          placeholder={t('FILTER_BY_STRING')}
          value={localValue}
        />
        {localValue ? (
          <s.TextConfirmButton onClick={onSubmit}>
            <s.MoreSearchIcon check name="check" />
          </s.TextConfirmButton>
        ) : (
          <s.MoreSearchIcon funnel name="funnel" />
        )}
      </s.PopupTextField>
    </s.MorePopup>
  );
};

ColumnPopupFilterText.propTypes = ColumnPopupFilterTextPropTypes;

export default React.memo(ColumnPopupFilterText);
